// extracted by mini-css-extract-plugin
export default {"post-container":"News_post-container__q792S","post-button-container":"News_post-button-container__N1OEw","post-button":"News_post-button__zsTsE","post-link":"News_post-link__8-ZNi"};